<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>淘客</el-breadcrumb-item>
          <el-breadcrumb-item>拼多多商品</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true">
          <el-form-item >
            <el-input  placeholder="名称" v-model="queryParam.keyword" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="Search" size="small">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="items" style="width: 100%">
          <el-table-column  prop="goodsName" :show-overflow-tooltip="true" fixed="left" label="名称"> </el-table-column>
          <el-table-column  prop="goodsImageUrl" label="图标" width="80" align="center">
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.goodsImageUrl"
                placement="right"
                trigger="hover"
              >
                <div>
                  <img
                    :src="scope.row.goodsImageUrl"
                    width="400"
                    
                  >
                </div>  
                <img
                  slot="reference"
                  :src="scope.row.goodsImageUrl"
                  width="20"
                  height="20"
                >
              </el-popover> 
              <p v-else>
                --
              </p>
            </template>         
          </el-table-column> 
          <el-table-column  prop="couponDiscount" label="优惠券金额"> </el-table-column>
          <el-table-column  prop="couponMinOrderAmount"   label="门槛价格"> </el-table-column>          
        </el-table>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div> 
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {        
        items:[],
        queryParam:{
          keyword:'',
          pageIndex:1,
          pagesize:10,
          totalCount:10,
          sort:' ReceiveTime asc',
        }
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/pdd/GoodsList',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.items = resp.data.goodsList
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val
        this.queryParam.pageIndex = 1 
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val
        this.GetData()
      },      
      PercenPtageFormat(row, column, cellValue, index){
        let value = row[column.property]
	      return  value +'%'
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>